import {
  AMEND_EXACT_GENERIC_FULFILLMENT_MSG,
  AMEND_GENERIC_REQUEST_RECEIVED_SUBSTR,
} from '@/constants/amendmentSupportCase'

/**
 * Runtime guards for `/amend/travellerDetails/:tripId` JSON before mapping.
 */
export function hasBookableTravellerPayload(data: unknown): boolean {
  if (!data || typeof data !== 'object') return false
  const dataObj = data as Record<string, unknown>
  const flights = dataObj?.flightList
  const pax = dataObj?.paxInfoList
  return (
    Array.isArray(flights) &&
    (flights?.length ?? 0) > 0 &&
    Array.isArray(pax) &&
    (pax?.length ?? 0) > 0
  )
}

export type EligibilityFailureFields = {
  clevertapKey: string
  errorMessage: string
  emailId: string
}

export function isGenericReceivedRequestMessage(message: string): boolean {
  const normalized = (message?.toLowerCase() ?? '').trim()
  if (normalized === AMEND_EXACT_GENERIC_FULFILLMENT_MSG.toLowerCase()) return true
  return normalized.includes(AMEND_GENERIC_REQUEST_RECEIVED_SUBSTR)
}

export function readEligibilityFailure(raw: unknown): EligibilityFailureFields {
  if (!raw || typeof raw !== 'object') {
    return { clevertapKey: '', errorMessage: '', emailId: '' }
  }
  const dataObj = raw as Record<string, unknown>
  const key = dataObj?.clevertapKey
  const msg = dataObj?.errorMessage
  const email = dataObj?.emailId
  const clevertapKey = key != null ? String(key) : ''
  const errorMessage = msg != null ? String(msg) : ''
  const emailId = email != null ? String(email) : ''
  return { clevertapKey, errorMessage, emailId }
}
